import React from "react";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "../styles/AuditHome.css";
import { DashBoardClinicalAudit } from "../scripts/DashBoardClinicalAudit";
// import { BasicTable } from '../scripts/Tables';
import { Dashboard } from "../scripts/Dashboard";
import { Box } from "@mui/system";
import { BasicTable } from "../scripts/Table2";
import { useLocation } from "react-router-dom";
import Api_Call from "../../ApiCall";

function AuditHomeTable2(data) {
  const [auditedData, setAuditedData] = useState("");
  const [pendingData, setPendingData] = useState("");
  const [completedData, setCompletedData] = useState("");
  const [progressData, setProgressData] = useState("");

  const [auditedNo, setAuditedNo] = useState(0);
  const [completedNo, setCompletedNo] = useState(0);
  const [progressNo, setProgressNo] = useState(0);
  const [pendingNo, setPendingNo] = useState(0);

  const memoizedPendingData = useMemo(() => pendingData, [pendingData]);
  // if(props.auditedData)
  // console.log(props.pendingData.body[0]['CountOfCases']['Disputed']);

  useEffect(() => {
    if (pendingData) {
      setAuditedNo(pendingData.body[0]["CountOfCases"]["Disputed"]);
      setCompletedNo(pendingData.body[0]["CountOfCases"]["Completed"]);
      setProgressNo(pendingData.body[0]["CountOfCases"]["InProgress"]);
      setPendingNo(pendingData.body[0]["CountOfCases"]["Pending"]);

      console.log(pendingData.body[0]["CountOfCases"]["Disputed"]);
    }
  }, [memoizedPendingData]);
  console.log(auditedNo, pendingNo, progressNo, completedNo);

  const location = useLocation();
  const selectedTile = new URLSearchParams(location.search).get("selectedTile");
  console.log(selectedTile);

  const [activeStyle, setActiveStyle] = useState({
    pending: false,
    inprogress: false,
    completed: false,
    audited: false,
  });

  console.log(activeStyle);

  // Creationg Columns for Audited Table
  const colsAudited = [
    {
      width: 100,
      Header: "CASE NO",
      accessor: "CASE_NO",
    },
    {
      width: 100,
      Header: "DATE OF PROCESSING",
      accessor: "DATE_OF_PROCESSING",
    },
    {
      width: 100,
      Header: "LAST ACTIVITY",
      accessor: "LAST_ACTIVITY",
    },
    {
      width: 100,
      Header: "DISPUTE ID",
      accessor: "DISPUTE_ID",
    },
    {
      width: 100,
      Header: "RAISE ON",
      accessor: "RAISEDON",
    },
    {
      width: 100,
      Header: "DISPUTE STATUS",
      accessor: "DISPUTE_STATUS",
    },
    {
      Header: "INITIAL SCORE",
      accessor: "INITIAL_SCORE",
      width: 100,
    },

    {
      width: 92,
      Header: "NURSE SCORE",
      accessor: "FNL_NURSE_SCORE",
    },
    {
      Header: "PROCESS SCORE",
      accessor: "FNL_PROCESS_SCORE",
      width: 100,
    },
  ];

  //Creating Table For Other Cases
  const cols = [
    {
      width: 100,
      Header: "CASE NO",
      accessor: "CASE_NO",
    },
    {
      width: 100,
      Header: "DATE OF PROCESSING",
      accessor: "DATE_OF_PROCESSING",
    },
    {
      width: 100,
      Header: activeStyle.audited ? "LAST ACTIVITY" : "BUSINESS LINE",
      accessor: activeStyle.audited ? "LAST_ACTIVITY" : "BUSINESS_LINE",
    },
    {
      width: 100,
      Header: activeStyle.audited ? "DISPUTE ID" : "REVIEW TYPE",
      accessor: activeStyle.audited ? "DISPUTE_ID" : "REVIEW_TYPE",
    },
    {
      width: 100,
      Header: activeStyle.audited ? "RAISE ON" : "WORK TYPE",
      accessor: activeStyle.audited ? "RAISEDON" : "WORK_TYPE",
    },
    {
      width: 100,
      Header: activeStyle.audited ? "DISPUTE STATUS" : "NURSE",
      accessor: activeStyle.audited ? "DISPUTE_STATUS" : "NURSE",
    },
    {
      Header: activeStyle.audited ? "SCORE" : "SUPERVISOR NAME",
      accessor: activeStyle.audited ? "INITIAL_SCORE" : "SUPERVISOR",
      width: 100,
    },
  ];

  const handleClick = (value) => {
    sessionStorage.setItem("ActiveTaskID", value);

    window.location.href = "/ClinicalAudit";
  };

  const [initialState, setInitialState] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const api = new Api_Call();
        const data = await api.getData("TASK-LIST?status=10&module=audit");
        // const response = await fetch(
        //   "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=10"
        // );
        // if (!response.ok) {
        //   throw new Error("Failed to fetch data");
        // }

        // const data = await response.json();

        console.log("Data from API:", data);
        setPendingData(data);
        console.log(data.body[0]["CountOfCases"]["Pending"]);
        setPendingNo(data.body[0]["CountOfCases"]["Pending"]);
      } catch (error) {
        console.error("API call error:", error.message);
      }
    };

    fetchData();
  }, []);

  const memoisedActiveStyle = useMemo(() => activeStyle, [activeStyle]);
  useEffect(() => {
    sessionStorage.setItem(
      "ActiveTileInAuditHome",
      Object.keys(activeStyle).filter((key) => activeStyle[key])
    );
  }, [memoisedActiveStyle]);

  const memoizedAuditedData = useMemo(() => auditedData, [auditedData]);

  useEffect(() => {
    console.log(memoizedAuditedData);
    if (selectedTile == "Audited") {
      //  taskQueueAuditedApi();
    }
  }, [memoizedAuditedData]);

  useEffect(() => {
    if (selectedTile == "Audited") taskQueueAuditedApi();
  }, [selectedTile]);

  console.log(selectedTile);

  console.log(auditedData);
  console.log(
    "Data for Table",
    activeStyle.audited
      ? auditedData
      : activeStyle.pending
      ? pendingData
      : activeStyle.completed
      ? completedData
      : activeStyle.inprogress
      ? progressData
      : []
  );

  const taskQueueApi = async () => {
    try {
      const api = new Api_Call();
      const data = await api.getData("TASK-LIST?status=10&module=audit");
      // const response = await fetch(
      //   "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=10"
      // );
      // if (!response.ok) {
      //   throw new Error("Failed to fetch data");
      // }

      // const data = await response.json();

      console.log("Data from API:", data);
      console.log("ApiRequest to Pending Made Made");
      setPendingData(data);
      setPendingNo(data.body[0]["CountOfCases"]["Pending"]);
    } catch (error) {
      console.error("API call error:", error.message);
    }

    setActiveStyle({
      ...activeStyle,
      pending: true,
      inprogress: false,
      completed: false,
      audited: false,
    });
  };

  const taskQueueCompletedApi = async () => {
    try {
      const api = new Api_Call();
      const data = await api.getData("TASK-LIST?status=12&module=audit");
      // const response = await fetch(
      //   "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=12"
      // );
      // if (!response.ok) {
      //   throw new Error("Failed to fetch data");
      // }

      // const data = await response.json();
      console.log("ApiRequest to Completed Made");
      console.log("Data from API:", data);
      setCompletedData(data);
      setCompletedNo(data.body[0]["CountOfCases"]["Completed"]);
    } catch (error) {
      console.error("API call error:", error.message);
    }

    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: false,
      completed: true,
      audited: false,
    });
  };
  const taskQueueInprogressApi = async () => {
    try {
      const api = new Api_Call();
      const data = await api.getData("TASK-LIST?status=11&module=audit");
      // const response = await fetch(
      //   "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=11"
      // );
      // if (!response.ok) {
      //   throw new Error("Failed to fetch data");
      // }

      // const data = await response.json();

      console.log("Data from API:", data);
      console.log("ApiRequest to InProgress Made");
      setProgressData(data);
      setProgressNo(data.body[0]["CountOfCases"]["InProgress"]);
    } catch (error) {
      console.error("API call error:", error.message);
    }

    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: true,
      completed: false,
      audited: false,
    });
  };

  const taskQueueAuditedApi = async () => {
    try {
      const api = new Api_Call();
      const data = await api.getData("TASK-LIST?status=15&module=audit");
      // const response = await fetch(
      //   "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=15"
      // );
      // if (!response.ok) {
      //   throw new Error("Failed to fetch data");
      // }

      // const data = await response.json();

      // console.log("Data from API:", data);
      setAuditedData(data);
      setAuditedNo(data.body[0]["CountOfCases"]["Disputed"]);
      console.log("ApiRequest to Audited Made");
    } catch (error) {
      console.error("API call error:", error.message);
    }

    setActiveStyle({
      ...activeStyle,
      pending: false,
      inprogress: false,
      completed: false,
      audited: true,
    });
  };

  const dashboardTasklist = [];
  return (
    <>
      <DashBoardClinicalAudit
        type="agent"
        dashboardTasklist={dashboardTasklist}
        handlePending={taskQueueApi}
        handleInprogress={taskQueueInprogressApi}
        handleCompleted={taskQueueCompletedApi}
        handleAudited={taskQueueAuditedApi}
        auditedData={auditedData}
        pendingData={pendingData}
        completedData={completedData}
        progressData={progressData}
        activeStyle={activeStyle}
        auditedNo={auditedNo}
        pendingNo={pendingNo}
        progressNo={progressNo}
        completedNo={completedNo}
      ></DashBoardClinicalAudit>

      <div className="content-main">
        <div className="user-content-container">
          <Box className="tasklist-table">
            <BasicTable
              activeStyle={activeStyle}
              columns={activeStyle.audited ? colsAudited : cols}
              tableData={
                activeStyle.audited
                  ? auditedData.body[0]["DisputedCases"]
                  : activeStyle.pending
                  ? pendingData.body[0]["Pending"]
                  : activeStyle.completed
                  ? completedData.body[0]["Completed"]
                  : activeStyle.inprogress
                  ? progressData.body[0]["InProgress"]
                  : []
              }
              tableType="default"
              AddButtonText=""
            ></BasicTable>
          </Box>
        </div>
      </div>
    </>
  );
}

export default AuditHomeTable2;
